<!-- 收货人信息页面 -->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="收货人信息" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="姓名" >
                <el-input type="text" autocomplete="off" v-model="formData.receiveMan" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
              <el-form-item label="联系方式" >
                <el-input type="text" autocomplete="off" v-model="formData.receiveMobile" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
              <el-form-item label="区域" >
                <template>
                  <el-cascader :props="areaProps" v-model="receiveAreaValues" :clearable="true" style="width:100%;" :disabled="able"
                    @change="handleChange2" ref="cascader2" :options="receiveAreaOption">
                  </el-cascader>
                </template>
              </el-form-item>
              <el-form-item label="详细地址" >
                <el-input type="text" autocomplete="off" v-model="formData.receiveAddress" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
              <el-form-item label="备注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>

              <div>
                <vxe-table style="margin-top: 5px;" :stripe="true"
                  :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                  :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                  show-overflow height="110" :column-config="{ resizable: true }"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                  @radio-change="radioChangeEvent"
                  :data="beforeBackList">
                  <vxe-column type="radio" width="40" />
                  <vxe-column field="itemCode" title="产品编码" width="250"></vxe-column>
                  <vxe-column field="itemName" title="产品名称" width="250"></vxe-column>
                  <vxe-column field="bigCategoryName" title="产品大类" width="150"></vxe-column>
                  <vxe-column field="smallCategoryName" title="产品小类" width="150"></vxe-column>
                  <vxe-column field="qty" title="数量" width="150">
                    <template #default="{ row }">
                      <vxe-input size="small" v-model="row.qty" type="number" min="1" max="1000"
                        :clearable="false"></vxe-input>
                      <span>{{ row.qty }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="price" title="单价" v-if="!isSite" width="150"></vxe-column>
                  <vxe-column field="amount" title="金额" v-if="!isSite" width="150"></vxe-column>
                  <vxe-column field="barcode" title="条码" v-if="!isSite" width="150"></vxe-column>
                </vxe-table>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
          bottom: 5px;
          right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  :diabled="siteAppealButton" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf'],
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
    this.getData()
  },
  data() {
    return {
      siteAppealButton: false,

      receiveAreaOption: [],
      receiveAreaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

      warehouseList: [],
      exchangeNo: '',
      beforeBackList: [],

      formData: {
        id: null,
        processId: null,
        taskId: null,
        messageContent:null,

        receiveMan:null,
        receiveMobile:null,
        receiveProvince: null,
        receiveCity: null,
        receiveCounty: null,
        receiveTown: null,
        receiveAreaId:null,
        receiveAddress:null,

        backList: [],
      },
      rules: {
        processId: [
          { required: true, prop: '流程id', message: '流程id不能为空', trigger: 'blur' }
        ],
        receiveMan: [
          { required: true, prop: '联系人', message: '联系人不能为空', trigger: 'blur' }
        ],
        receiveMobile: [
          { required: true, prop: '联系方式', message: '联系方式不能为空', trigger: 'blur' }
        ],
        receiveProvince: [
          { required: true, prop: '省', message: '省不能为空', trigger: 'blur' }
        ],
        receiveCity: [
          { required: true, prop: '市', message: '市不能为空', trigger: 'blur' }
        ],
        receiveCounty: [
          { required: true, prop: '区', message: '区不能为空', trigger: 'blur' }
        ],
        receiveAreaId: [
          { required: true, prop: '区域id', message: '区域id不能为空', trigger: 'blur' }
        ],
        receiveAddress: [
          { required: true, prop: '地址', message: '地址不能为空', trigger: 'blur' }
        ],
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    loadWarehouse() {
			this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
			}).then(res => {
				this.warehouseList = res.data.data
			})
		},

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.formData.backList = data.records
    },

    radioChangeEvent(data) {
      console.log('选中数据', data)
      this.formData.backList.clear
      this.formData.backList.push(data.row)
    },

    getData() {
      console.log('getData', this.dataId)

      if (this.formData.id && !isNaN(this.formData.id)) {
        this.$http({
          url: api.wkExchangeBill.getDataUrl + this.formData.id,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.spPartsApplyOperationDTOList === null || data.spPartsApplyOperationDTOList === undefined) {
            data.spPartsApplyOperationDTOList = []
          }
          this.beforeBackList = data.backList
        })
      }
    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址选中事件
    handleChange2() {
      const areaNode = this.$refs["cascader2"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.receiveCountry = areaNode[0].label;
          this.formData.receiveProvince = null;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.receiveProvince = areaNode[0].label;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.receiveCity = areaNode[0].label;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.receiveCounty = areaNode[0].label;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.receiveTown = areaNode[0].label;
        }
        this.formData.receiveAreaId = areaNode[0].value
      } else {
        this.formData.receiveAreaId = null;
        this.formData.receiveCountry = null;
        this.formData.receiveProvince = null;
        this.formData.receiveCity = null;
        this.formData.receiveCounty = null;
        this.formData.receiveTown = null;
      }

      const panelRefs = this.$refs.cascader2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },


    // 考核的确认
    siteAppeal() {
      if (!this.formData.backList || this.formData.backList.length != 1) {
        this.$message.error('请选择一个机型')
        return false;
      }
      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要提交吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: "/basic/wkExchangeBill/affirmVersion",
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$mask.close()
            this.$message.success('提交成功')
            this.$emit('closeD')
            this.$emit('flushed')
          }).catch(() => {
            this.$mask.close()
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadWarehouse()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
